<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-3">
        <SearchFilters
          :industry-options="industryOptions"
          :size-options="sizeOptions"
          :cf-options="cfOptions"
          :outlet-pressure-range-options="outletPressureRangeOptions"
          :url-builder="urlBuilder"
          v-model:industry-filter="industryFilter"
          v-model:size-filter="sizeFilter"
          v-model:cf-filter="cfFilter"
          v-model:outlet-pressure-range-filter="outletPressureRangeFilter"
        />
      </div>
      <div class="col-12 col-md-9">
        <SearchResults
          :models="models"
          @load-more="loadMore"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* global models, industryOptions, sizeOptions, cfOptions, outletPressureRangeOptions, pageUrl */

import SearchFilters from './components/SearchFilters.vue'
import SearchResults from './components/SearchResults.vue'

export default {
  name: 'ModelSearch',
  components: {
    SearchFilters,
    SearchResults
  },
  data () {
    return {
      allModels: models,
      models: [],
      industryOptions: industryOptions,
      sizeOptions: sizeOptions,
      cfOptions: cfOptions,
      outletPressureRangeOptions: outletPressureRangeOptions,
      industryFilter: [],
      sizeFilter: [],
      cfFilter: [],
      outletPressureRangeFilter: [],
      pageUrl: pageUrl,
      urlBuilder: '',
      maxToShow: 18,
      pageSize: 18,
      currentlyShowing: 0,
      useLocalStorage: false,
      loadingComplete: false
    }
  },
  created: function () {
    if (typeof localStorage !== 'undefined') {
      this.useLocalStorage = true
    }

    var urlParams = [];
    (window.onpopstate = function () {
      var match
      var pl = /\+/g // Regex for replacing addition symbol with a space
      var search = /([^&=]+)=?([^&]*)/g
      var decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')) }
      var query = window.location.search.substring(1)

      var filters = ['industries', 'sizes', 'cfs']

      while ((match = search.exec(query))) {
        if (filters.indexOf(decode(match[1])) >= 0) {
          urlParams.push({ name: decode(match[1]), value: decodeURIComponent(match[2]) })
        }
      }
    })()

    // if we have urlParams load the data from those, otherwise load from local storage if we have it
    if (urlParams.length) {
      this.industryFilter = []
      this.sizeFilter = []
      this.cfFilter = []
      this.outletPressureRangeFilter = []

      urlParams.forEach(function (urlParam) {
        var paramValue = parseInt(urlParam.value)
        switch (urlParam.name) {
          case 'industries':
            this.industryFilter.push(paramValue)
            break
          case 'sizes':
            this.sizeFilter.push(paramValue)
            break
          case 'cfs':
            this.cfFilter.push(paramValue)
            break
          case 'outlet_pressure_ranges':
            this.outletPressureRangeFilter.push(paramValue)
            break
        }
      }, this)
    } else {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        this.industryFilter = (localStorage.getItem('usg_industryFilter') === null) ? [] : JSON.parse(localStorage.getItem('usg_industryFilter'))
        this.sizeFilter = (localStorage.getItem('usg_sizeFilter') === null) ? [] : JSON.parse(localStorage.getItem('usg_sizeFilter'))
        this.cfFilter = (localStorage.getItem('usg_cfFilter') === null) ? [] : JSON.parse(localStorage.getItem('usg_cfFilter'))
        this.outletPressureRangeFilter = (localStorage.getItem('usg_outletPressureRangeFilter') === null) ? [] : JSON.parse(localStorage.getItem('usg_outletPressureRangeFilter'))
      }
    }

    this.buildUrl()
    this.filterModels()
    this.loadingComplete = true
  },
  watch: {
    industryFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('usg_industryFilter', JSON.stringify(this.industryFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    sizeFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('usg_sizeFilter', JSON.stringify(this.sizeFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    cfFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('usg_cfFilter', JSON.stringify(this.cfFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    },
    outletPressureRangeFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('usg_outletPressureRangeFilter', JSON.stringify(this.outletPressureRangeFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 18
          this.buildUrl()
          this.filterModels()
        }
      },
      deep: true
    }
  },
  methods: {
    buildUrl: function () {
      var query = ''
      if (this.industryFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.industryFilter.map(function (value) {
          return 'industries=' + value
        }).join('&')
      }
      if (this.sizeFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.sizeFilter.map(function (value) {
          return 'sizes=' + value
        }).join('&')
      }
      if (this.cfFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.cfFilter.map(function (value) {
          return 'cfs=' + value
        }).join('&')
      }
      if (this.outletPressureRangeFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.outletPressureRangeFilter.map(function (value) {
          return 'outlet_pressure_ranges=' + value
        }).join('&')
      }

      if (query.length) {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0] + '?' + query)
      } else {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0])
      }
      this.urlBuilder = pageUrl + '?' + query
    },
    filterModels: function () {
      this.currentlyShowing = 0
      this.models = []

      for (var i = 0; i < this.allModels.length; i++) {
        var hide = false
        this.currentlyShowing++
        var checkModel = this.allModels[i]

        if (!hide) {
          if (this.industryFilter.length) {
            // if this model matches any of the selected sizes, show it
            var industryMatched = false
            for (var j = 0; j < this.industryFilter.length; j++) {
              var checkIndustry = parseInt(this.industryFilter[j])
              if (checkModel.industry.length) {
                for (var x = 0; x < checkModel.industry.length; x++) {
                  var checkModelIndustry = parseInt(checkModel.industry[x])
                  if (checkIndustry === checkModelIndustry) {
                    industryMatched = true
                  }
                }
              }
            }

            if (!industryMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.sizeFilter.length) {
            // if this model matches any of the selected sizes, show it
            var sizeMatched = false
            for (var k = 0; k < this.sizeFilter.length; k++) {
              var checkSize = parseInt(this.sizeFilter[k])
              if (checkModel.size.length) {
                for (var y = 0; y < checkModel.size.length; y++) {
                  var checkModelSize = parseInt(checkModel.size[y])
                  if (checkSize === checkModelSize) {
                    sizeMatched = true
                  }
                }
              }
            }

            if (!sizeMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.cfFilter.length) {
            var cfMatched = true
            if (this.cfFilter.indexOf(checkModel.cf) < 0) {
              cfMatched = false
            }

            if (!cfMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (!hide) {
          if (this.outletPressureRangeFilter.length) {
            var outletPressureRangeMatched = true
            if (this.outletPressureRangeFilter.indexOf(checkModel.outlet_pressure_range) < 0) {
              outletPressureRangeMatched = false
            }

            if (!outletPressureRangeMatched) {
              hide = true
              this.currentlyShowing--
            }
          }
        }

        if (this.currentlyShowing > this.maxToShow) {
          hide = true
        }

        if (!hide) {
          this.models.push(checkModel)
        }
      }
    },
    loadMore: function () {
      this.maxToShow += this.pageSize
      this.filterModels()
    }
  }
}
</script>
